import React from 'react';
import AnalysisPage from './AnalysisPage'

const AlertService = () => {
    const filters = [
        {
            name: "Type",
            type: "dropdown",
            options: ["HVAC Restoration", "Thermostat"],
        },
        {
            name: "Spend",
            type: "button",
        },
        {
            name: "Quality",
            type: "button",
        },
        {
            name: "Hourly",
            type: "date",
        },
        {
            name: "Start Date",
            type: "date",
        },
        {
            name: "End Date",
            type: "date",
        },
    ];

    return (
        <AnalysisPage title="Service" filters={filters}></AnalysisPage>
    )
};

export default AlertService;
